import React, { useState, useEffect, useRef } from "react";
// @ts-ignore
import Flag from "react-world-flags";
import "./CountryPrefixInput.css";

export const countries = [
  { name: "Ireland", code: "+353", flag: "IE" },
  { name: "United Kingdom", code: "+44", flag: "GB" },
  { name: "Spain", code: "+34", flag: "ES" },
  { name: "France", code: "+33", flag: "FR" },
  { name: "Cook Islands", code: "+682", flag: "CK" },
  { name: "Niue", code: "+683", flag: "NU" },
  { name: "Samoa", code: "+685", flag: "WS" },
  { name: "Kiribati", code: "+686", flag: "KI" },
  { name: "New Caledonia", code: "+687", flag: "NC" },
  { name: "Tuvalu", code: "+688", flag: "TV" },
  { name: "French Polynesia", code: "+689", flag: "PF" },
  { name: "Tokelau", code: "+690", flag: "TK" },
  { name: "Micronesia", code: "+691", flag: "FM" },
  { name: "Marshall Islands", code: "+692", flag: "MH" },
  { name: "Russia", code: "+7", flag: "RU" },
  { name: "Japan", code: "+81", flag: "JP" },
  { name: "South Korea", code: "+82", flag: "KR" },
  { name: "Vietnam", code: "+84", flag: "VN" },
  { name: "Hong Kong", code: "+852", flag: "HK" },
  { name: "Macao SAR, China", code: "+853", flag: "MO" },
  { name: "Cambodia", code: "+855", flag: "KH" },
  { name: "Laos", code: "+856", flag: "LA" },
  { name: "China", code: "+86", flag: "CN" },
  { name: "Taiwan", code: "+886", flag: "TW" },
  { name: "Türkiye", code: "+90", flag: "TR" },
  { name: "India", code: "+91", flag: "IN" },
  { name: "Pakistan", code: "+92", flag: "PK" },
  { name: "Sri Lanka", code: "+94", flag: "LK" },
  { name: "Maldives", code: "+960", flag: "MV" },
  { name: "Lebanon", code: "+961", flag: "LB" },
  { name: "Jordan", code: "+962", flag: "JO" },
  { name: "Kuwait", code: "+965", flag: "KW" },
  { name: "Saudi Arabia", code: "+966", flag: "SA" },
  { name: "Palestine", code: "+970", flag: "PS" },
  { name: "United Arab Emirates", code: "+971", flag: "AE" },
  { name: "Israel", code: "+972", flag: "IL" },
  { name: "Bahrain", code: "+973", flag: "BH" },
  { name: "Qatar", code: "+974", flag: "QA" },
  { name: "Mongolia", code: "+976", flag: "MN" },
  { name: "Nepal", code: "+977", flag: "NP" },
  { name: "Turkmenistan", code: "+993", flag: "TM" },
  { name: "Georgia", code: "+995", flag: "GE" },
  { name: "Kyrgyzstan", code: "+996", flag: "KG" },
  { name: "United States", code: "+1", flag: "US" },
  { name: "Canada", code: "+1", flag: "CA" },
  { name: "Australia", code: "+61", flag: "AU" },
  { name: "New Zealand", code: "+64", flag: "NZ" },
  { name: "Germany", code: "+49", flag: "DE" },
  { name: "Italy", code: "+39", flag: "IT" },
  { name: "Brazil", code: "+55", flag: "BR" },
  { name: "South Africa", code: "+27", flag: "ZA" },
  { name: "Argentina", code: "+54", flag: "AR" },
  { name: "Mexico", code: "+52", flag: "MX" },
  { name: "Indonesia", code: "+62", flag: "ID" },
  { name: "Philippines", code: "+63", flag: "PH" },
];

export const CountryPrefixInput: React.FC<{
  onPrefixChange: (prefix: string) => void;
  className?: string;
  codeClassName?: string;
  selectedPrefix?: string;
  disabled?: boolean;
}> = ({
  onPrefixChange,
  className,
  codeClassName,
  selectedPrefix,
  disabled = false,
}) => {
  // const [selectedCountry, setSelectedCountry] = useState(countries[0]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const dropdownRef = useRef<HTMLDivElement>(null);
  const [selectedCountry, setSelectedCountry] = useState(
    countries.find((country) => country.code === selectedPrefix) || countries[0]
  );

  useEffect(() => {
    // Update the selected country whenever the selectedPrefix changes
    const newSelectedCountry = countries.find(
      (country) => country.code === selectedPrefix
    );
    if (newSelectedCountry) {
      setSelectedCountry(newSelectedCountry);
    }
  }, [selectedPrefix]);
  // Handle country selection
  const handleCountrySelect = (country: any) => {
    if (disabled) return;
    setSelectedCountry(country); // Update the selected country
    setIsDropdownOpen(false);
    onPrefixChange(country.code); // Notify the parent of the selected prefix
  };

  // Filter countries based on the search term
  const filteredCountries = countries.filter((country) =>
    country.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Handle clicks outside the dropdown to close it
  const handleClickOutside = (event: MouseEvent) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target as Node)
    ) {
      setIsDropdownOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Render the component
  return (
    <div
      className={`cp-input-container ${disabled ? "cp-disabled" : ""}`} // Add disabled class
      ref={dropdownRef}
    >
      <div
        className={`cp-selector ${className || ""} ${
          disabled ? "cp-disabled" : ""
        }`}
        onClick={() => !disabled && setIsDropdownOpen(!isDropdownOpen)} // Prevent opening dropdown if disabled
      >
        <div className="cp-flag-circle">
          <Flag code={selectedCountry.flag} />
        </div>
        <span className={codeClassName || ""}>{selectedCountry.code}</span>
      </div>
      {isDropdownOpen && !disabled && (
        <div className="cp-dropdown">
          <div className="cp-dropdown-search-container">
            <input
              type="text"
              placeholder="Search"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="cpi-dropdown-search"
            />
            <i className="cp-search-icon fas fa-search"></i>
          </div>
          <ul className="cp-dropdown-list">
            {filteredCountries.map((country) => (
              <li
                key={country.name}
                onClick={() => handleCountrySelect(country)}
                className="cp-dropdown-item"
              >
                <div className="cp-flag-circle">
                  <Flag code={country.flag} />
                </div>
                <p
                  className={codeClassName || ""}
                  style={
                    codeClassName ? { fontSize: "14px", marginLeft: "5px" } : {}
                  }
                >
                  {country.code}
                </p>
                <span>{country.name}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default CountryPrefixInput;
